import * as React from 'react';

export interface SubPanelProps {
	/** Icona iniziale nella riga del titolo (colorata ad accento). */
	icon?: React.ReactNode;
	/** Titolo del sotto-pannello. */
	title: React.ReactNode;
	/** Descrizione breve sotto il titolo. */
	description?: React.ReactNode;
	/** Contenuto del pannello. */
	children?: React.ReactNode;
}

/** Pannello bordato annidato dentro una sezione: riga di titolo, descrizione breve, contenuto. */
const SubPanel = ({ icon, title, description, children }: SubPanelProps) => (
	<div className="rounded-lg border border-border bg-background/50 p-3">
		<div className="mb-2 flex items-center gap-2 text-[13px] font-semibold text-text">
			{icon && <span className="shrink-0 text-accent [&_svg]:h-3.5 [&_svg]:w-3.5">{icon}</span>}
			{title}
		</div>
		{description && <p className="mb-3 text-[11px] text-text-muted">{description}</p>}
		{children}
	</div>
);
SubPanel.displayName = 'SubPanel';

export { SubPanel };
